import React from "react";
import {
  FileKey2,
  FileTerminal,
  LockKeyhole,
  LogOut,
  Server,
  Settings,
  SlidersHorizontal,
  Smartphone,
  UserCircle,
  Wrench,
} from "lucide-react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LogOutAdminAction } from "store/middlewares/session/auth";
import DefaultImg from "assets/images/PNG/blank.png";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "components/ui";
import checkAccess from "utils/checkAccess";
import { SmartImage } from "components/atoms";
import { closeAdminModal, openAdminModal } from "store/slices/common/adminModal.slice";

const UserDropdownMenu = ({ trigger }) => {
  const { me } = useSelector((state) => state.me);
  const dispatch = useDispatch();

  // Use display data from currentUser
  const displayName = me?.name;

  const displayEmail = me?.email;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent className="w-64" side="bottom" align="end">
        {/* Header */}

        <div className="flex items-center justify-between p-3">
          <Link to="/public-profile/profile">
            <div className="flex items-center gap-2">
              {/* <img
                className="size-9 rounded-full border-2 border-green-500"
                src={me?.profile_url ?? DefaultImg}
                alt="User avatar"
              /> */}

              <div className="cursor-pointer size-9 rounded-full justify-center shrink-0 overflow-hidden border-2 border-green-500">
                <SmartImage
                  src={me?.profile_url ?? DefaultImg}
                  alt="User"
                  // className="cursor-pointer size-9 rounded-full justify-center shrink-0"
                  fallback={
                    <div className="bg-[#d3e6ff] flex justify-center items-center">
                      <img
                        src={DefaultImg}
                        alt="flag"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  }
                />
              </div>

              <div className="flex flex-col">
                <div
                  className="text-sm text-mono hover:text-primary font-semibold "
                  style={{ overflowWrap: "anywhere" }}
                >
                  {displayName}
                </div>
                {/* <a
                  href={`mailto:${displayEmail}`}
                  className="text-xs text-muted-foreground hover:text-primary"
                >
                  {displayEmail}
                </a> */}
                <span
                  className="text-xs text-muted-foreground cursor-text select-text"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  {displayEmail}
                </span>
              </div>
            </div>
          </Link>
          {/* <Badge variant="primary" appearance="outline" size="sm">
            Pro
          </Badge> */}
        </div>

        <DropdownMenuSeparator />

        {/* Menu Items */}
        <DropdownMenuItem asChild>
          <Link
            to="/public-profile/profile"
            className="flex items-center gap-2"
          >
            <UserCircle />
            My Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link
            to="/public-profile/change-password"
            className="flex items-center gap-2"
          >
            <LockKeyhole />
            Change Password
          </Link>
        </DropdownMenuItem>

        <DropdownMenuItem asChild>
          <Link to="/settings" className="flex items-center gap-2">
            <Settings />
            Settings
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/defaultPreferences" className="flex items-center gap-2">
            <SlidersHorizontal />
            Default Preferences
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSub>
          <DropdownMenuSubTrigger className="flex items-center gap-2 outline-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 data-[state=open]:bg-accent">
            <Smartphone />
            Get the Apps
          </DropdownMenuSubTrigger>

          <DropdownMenuSubContent className="w-44">
            <DropdownMenuItem asChild>
              <Link
                to="/get-the-app/ios"
                className="flex items-center gap-2 outline-none focus:outline-none"
              >
                iOS App
              </Link>
            </DropdownMenuItem>

            <DropdownMenuItem asChild>
              <Link
                to="/get-the-app/android"
                className="flex items-center gap-2 outline-none focus:outline-none"
              >
                Android App
              </Link>
            </DropdownMenuItem>
          </DropdownMenuSubContent>
        </DropdownMenuSub>
        {checkAccess("read_terms") && (
          <DropdownMenuItem asChild>
            <Link to="/terms" className="flex items-center gap-2">
              <FileTerminal />
              Terms And Conditions
            </Link>
          </DropdownMenuItem>
        )}
        {checkAccess("read_privacy") && (
          <DropdownMenuItem asChild>
            <Link to="/privacy" className="flex items-center gap-2">
              <FileKey2 />
              Privacy Policy
            </Link>
          </DropdownMenuItem>
        )}
        <DropdownMenuItem asChild>
          <Link to="/maintenance-mode" className="flex items-center gap-2">
            <Wrench />
            Maintenance Mode
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <a
            href="https://ceph-dashboard.bigfootmail.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2"
          >
            <Server />
            Ceph Server
          </a>
        </DropdownMenuItem>
        {/* My Account Submenu */}
        {/* <DropdownMenuSub>
          <DropdownMenuSubTrigger className="flex items-center gap-2 outline-transparent">
            <FileText />
            CMS
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent className="w-52">
            <DropdownMenuItem asChild>
              <Link
                to="/cms/terms"
                className="flex items-center gap-2"
              >
                <FileTerminal />
                Terms And Conditions
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link
                to="/cms/privacy"
                className="flex items-center gap-2"
              >
                <FileKey2 />
                Privacy Policy
              </Link>
            </DropdownMenuItem>
          </DropdownMenuSubContent>
        </DropdownMenuSub> */}

        {/* <DropdownMenuItem asChild>
          <Link
            to="https://devs.keenthemes.com"
            className="flex items-center gap-2"
          >
            <SquareCode />
            Dev Forum
          </Link>
        </DropdownMenuItem> */}

        {/* Language Submenu with Radio Group */}
        {/* <DropdownMenuSub>
          <DropdownMenuSubTrigger className="flex items-center outline-transparent gap-2 [&_[data-slot=dropdown-menu-sub-trigger-indicator]]:hidden hover:[&_[data-slot=badge]]:border-input data-[state=open]:[&_[data-slot=badge]]:border-input">
            <Globe />
            <span className="flex items-center justify-between gap-2 grow relative">
              Language
            </span>
          </DropdownMenuSubTrigger>
        </DropdownMenuSub> */}

        <DropdownMenuSeparator />

        {/* Footer */}

        {/* Footer */}
        <DropdownMenuItem asChild>
          <div className="p-2 pb-0 mt-0">
            <Button
              variant="outline"
              size="sm"
              className="w-full"
              onClick={() => {
                dispatch(
                  openAdminModal({
                    title: "",
                    content: (
                      <div className="grid gap-5 p-1">
                        {/* Title with icon */}
                        <div className="flex items-center gap-3.5">
                          <div className="flex size-11 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600">
                            <LogOut className="size-5" aria-hidden="true" />
                          </div>
                          <h2 className="text-xl font-bold text-foreground">
                            Logout of your account?
                          </h2>
                        </div>

                        {/* What happens */}
                        <ul className="grid gap-2">
                          <li className="flex items-start gap-2.5 text-sm leading-6 text-secondary-foreground">
                            <span className="mt-2.5 size-1.5 shrink-0 rounded-full bg-muted-foreground" />
                            <span className="break-words">
                              You will need to sign in again to access your account.
                            </span>
                          </li>
                          <li className="flex items-start gap-2.5 text-sm leading-6 text-secondary-foreground">
                            <span className="mt-2.5 size-1.5 shrink-0 rounded-full bg-muted-foreground" />
                            <span>Any unsaved changes will be lost.</span>
                          </li>
                          <li className="flex items-start gap-2.5 text-sm leading-6 text-secondary-foreground">
                            <span className="mt-2.5 size-1.5 shrink-0 rounded-full bg-muted-foreground" />
                            <span>You can sign back in at any time.</span>
                          </li>
                        </ul>

                        {/* Actions */}
                        <div className="flex justify-end gap-3">
                          <Button
                            type="button"
                            variant="outline"
                            size="lg"
                            onClick={() => dispatch(closeAdminModal())}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="button"
                            variant="destructive"
                            size="lg"
                            onClick={() => {
                              dispatch(LogOutAdminAction());
                              dispatch(closeAdminModal());
                            }}
                          >
                            Logout
                          </Button>
                        </div>
                      </div>
                    ),
                  })
                );
              }}
            >
              Logout
            </Button>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserDropdownMenu;
